import React from "react";
import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Heart,
  Code,
} from "lucide-react";
import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src={logo} className="h-8 w-8 text-blue-500" />
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                ThoughtCode
              </span>
            </div>
            <p className="mb-6 text-gray-400 max-w-xs">
              Helping tech professionals discover resume templates, preparation
              resources, and their dream jobs to advance their careers.
            </p>
            {/* <div className="flex space-x-4">
              <SocialIcon icon={<Facebook className="h-5 w-5" />} href="#" />
              <SocialIcon icon={<Twitter className="h-5 w-5" />} href="#" />
              <SocialIcon icon={<Linkedin className="h-5 w-5" />} href="#" />
              <SocialIcon icon={<Instagram className="h-5 w-5" />} href="#" />
            </div> */}
          </div>

          <div>
            <h3 className="text-white font-semibold text-lg mb-4">
              For Job Seekers
            </h3>
            <ul className="space-y-3">
              <FooterLink href="/jobs">Browse Jobs</FooterLink>
              <FooterLink href="/prepare">Interview Preparation</FooterLink>
              <FooterLink href="/resume">Resume Builder</FooterLink>
              <FooterLink href="/prepare">Career Resources</FooterLink>
              {/* <FooterLink href="#">Salary Guide</FooterLink> */}
            </ul>
          </div>
          {/* 
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">
              For Employers
            </h3>
            <ul className="space-y-3">
              <FooterLink href="#">Post a Job</FooterLink>
              <FooterLink href="#">Find Candidates</FooterLink>
              <FooterLink href="#">Recruitment Solutions</FooterLink>
              <FooterLink href="#">Pricing</FooterLink>
              <FooterLink href="#">Employer Resources</FooterLink>
            </ul>
          </div> */}

          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <FooterLink href="/aboutus">About Us</FooterLink>
              <FooterLink href="/contact-us">Contact</FooterLink>
              <FooterLink href="/prepare">Blog</FooterLink>
              <FooterLink href="/privacy-policy">Privacy Policy</FooterLink>
              <FooterLink href="/terms-of-service">Terms of Service</FooterLink>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8 text-center text-gray-400 text-sm">
          <p className="flex items-center justify-center">
            Made with{" "}
            <Heart className="h-4 w-4 text-red-500 mx-1 fill-current" /> by
            ThoughtCode Team
          </p>
          <p className="mt-2">
            © {new Date().getFullYear()} ThoughtCode. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

const SocialIcon = ({ icon, href }) => (
  <a
    href={href}
    className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition-colors"
  >
    {icon}
  </a>
);

const FooterLink = ({ href, children }) => (
  <li>
    <a
      href={href}
      className="text-gray-400 hover:text-blue-400 transition-colors"
    >
      {children}
    </a>
  </li>
);

export default Footer;
